<div class="client-contact-ac">
  <!-- Line 1: 20px — name + subtitle (left), country flag + label (right) -->
  <div class="client-contact-ac__line client-contact-ac__line--primary">
    <span class="client-contact-ac__title-line">
      <span class="client-contact-ac__name">{{ primaryName }}</span>
      <ng-container *ngIf="subtitle">
        <span class="client-contact-ac__sep"> · </span>
        <span class="client-contact-ac__sub">{{ subtitle }}</span>
      </ng-container>
    </span>
    <span class="client-contact-ac__country" *ngIf="country as ctry">
      <ws-flag [countryCode]="ctry.iso" size="small"></ws-flag>
      <span class="client-contact-ac__ellipsis client-contact-ac__country-label">{{
        ctry.label
      }}</span>
    </span>
  </div>

  <!-- Line 2: 20px — email, phone -->
  <div class="client-contact-ac__line client-contact-ac__line--meta">
    <span class="client-contact-ac__segment client-contact-ac__segment--email" *ngIf="contact.email">
      <span class="material-icons client-contact-ac__ico">mail_outline</span>
      <span class="client-contact-ac__ellipsis">{{ contact.email }}</span>
    </span>
    <span class="client-contact-ac__segment client-contact-ac__segment--phone" *ngIf="phoneDisplay as phone">
      <span class="material-icons client-contact-ac__ico">phone</span>
      <span class="client-contact-ac__ellipsis">{{ phone }}</span>
    </span>
  </div>

  <ng-container *ngIf="false">
    <div class="client-contact-ac__head-side" *ngIf="showValueChips">
      <span
        class="client-contact-ac__chip"
        *ngIf="evaluation !== undefined"
        [attr.title]="'Value' | translate"
        >{{ evaluation }}</span
      >
      <span
        class="client-contact-ac__chip client-contact-ac__chip--extra"
        *ngIf="customerValueDisplay as cv"
        [attr.title]="'Value' | translate"
        >{{ cv }}</span
      >
    </div>
  </ng-container>

  <ng-container *ngIf="false">
    <div class="client-contact-ac__tags" *ngIf="tagsPreview as tp">
      <span class="material-icons client-contact-ac__tags-ico" aria-hidden="true"
        >local_offer</span
      >
      <span class="client-contact-ac__tag" *ngFor="let t of tp.tags">{{ t }}</span>
      <span class="client-contact-ac__tag client-contact-ac__tag--more" *ngIf="tp.more > 0"
        >+{{ tp.more }}</span
      >
    </div>
  </ng-container>
</div>
